import { createMutationHelper } from '@utils/swr'
import { type LineSubscriptionRequest } from '../../../types/apiRequest'
import { type LineSubscriptionResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const {
  useMutation,
} = createMutationHelper<CosignApis['post']['lineSubscription'], LineSubscriptionResponse, LineSubscriptionRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/line-subscription',
  fetcher: (url, { arg, client }) => {
    return client.post(url, arg)
  },
})

export const useRequestLineSubscription = useMutation
